var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-header-index-wide" },
    [
      _c(
        "a-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 4 },
            },
            [
              _c(
                "chart-card",
                {
                  attrs: {
                    loading: _vm.loading,
                    title: "今日销售",
                    "data-step": "1",
                    "data-title": "今日销售",
                    "data-intro": "统计今日销售单据的总金额",
                  },
                },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        slot: "action",
                        title: "统计今日销售单据的总金额",
                      },
                      slot: "action",
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("head-info", {
                    attrs: { content: _vm.statistics.todaySale },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 4 },
            },
            [
              _c(
                "chart-card",
                {
                  attrs: {
                    loading: _vm.loading,
                    title: "今日零售",
                    "data-step": "2",
                    "data-title": "今日零售",
                    "data-intro": "统计今日零售单据的总金额",
                  },
                },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        slot: "action",
                        title: "统计今日零售单据的总金额",
                      },
                      slot: "action",
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("head-info", {
                    attrs: { content: _vm.statistics.todayRetailSale },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 4 },
            },
            [
              _c(
                "chart-card",
                {
                  attrs: {
                    loading: _vm.loading,
                    title: "今日采购",
                    "data-step": "3",
                    "data-title": "今日采购",
                    "data-intro": "统计今日采购单据的总金额",
                  },
                },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        slot: "action",
                        title: "统计今日采购单据的总金额",
                      },
                      slot: "action",
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("head-info", {
                    attrs: { content: _vm.statistics.todayBuy },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 4 },
            },
            [
              _c(
                "chart-card",
                { attrs: { loading: _vm.loading, title: "本月累计销售" } },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        slot: "action",
                        title: "统计本月销售单据的总金额",
                      },
                      slot: "action",
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("head-info", {
                    attrs: { content: _vm.statistics.monthSale },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 4 },
            },
            [
              _c(
                "chart-card",
                { attrs: { loading: _vm.loading, title: "本月累计零售" } },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        slot: "action",
                        title: "统计本月零售单据的总金额",
                      },
                      slot: "action",
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("head-info", {
                    attrs: { content: _vm.statistics.monthRetailSale },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 4 },
            },
            [
              _c(
                "chart-card",
                { attrs: { loading: _vm.loading, title: "本月累计采购" } },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        slot: "action",
                        placement: "left",
                        title: "统计本月采购单据的总金额",
                      },
                      slot: "action",
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("head-info", {
                    attrs: { content: _vm.statistics.monthBuy },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 4 },
            },
            [
              _c(
                "chart-card",
                { attrs: { loading: _vm.loading, title: "昨日销售" } },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        slot: "action",
                        title: "统计昨日销售单据的总金额",
                      },
                      slot: "action",
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("head-info", {
                    attrs: { content: _vm.statistics.yesterdaySale },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 4 },
            },
            [
              _c(
                "chart-card",
                { attrs: { loading: _vm.loading, title: "昨日零售" } },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        slot: "action",
                        title: "统计昨日零售单据的总金额",
                      },
                      slot: "action",
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("head-info", {
                    attrs: { content: _vm.statistics.yesterdayRetailSale },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 4 },
            },
            [
              _c(
                "chart-card",
                { attrs: { loading: _vm.loading, title: "昨日采购" } },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        slot: "action",
                        title: "统计昨日采购单据的总金额",
                      },
                      slot: "action",
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("head-info", {
                    attrs: { content: _vm.statistics.yesterdayBuy },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 4 },
            },
            [
              _c(
                "chart-card",
                { attrs: { loading: _vm.loading, title: "今年累计销售" } },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        slot: "action",
                        title: "统计今年销售单据的总金额",
                      },
                      slot: "action",
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("head-info", {
                    attrs: { content: _vm.statistics.yearSale },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 4 },
            },
            [
              _c(
                "chart-card",
                { attrs: { loading: _vm.loading, title: "今年累计零售" } },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        slot: "action",
                        title: "统计今年零售单据的总金额",
                      },
                      slot: "action",
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("head-info", {
                    attrs: { content: _vm.statistics.yearRetailSale },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 4 },
            },
            [
              _c(
                "chart-card",
                { attrs: { loading: _vm.loading, title: "今年累计采购" } },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        slot: "action",
                        placement: "left",
                        title: "统计今年采购单据的总金额",
                      },
                      slot: "action",
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("head-info", {
                    attrs: { content: _vm.statistics.yearBuy },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 8 },
            },
            [
              _c(
                "a-card",
                {
                  attrs: {
                    loading: _vm.loading,
                    bordered: false,
                    "body-style": { paddingRight: "5" },
                    "data-step": "4",
                    "data-title": "销售统计",
                    "data-intro": "统计往前6个月每月销售的总金额",
                  },
                },
                [
                  _c("bar", {
                    attrs: {
                      title: "销售统计",
                      height: _vm.barHeight,
                      yaxisText: _vm.yaxisText,
                      dataSource: _vm.salePriceData,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 8 },
            },
            [
              _c(
                "a-card",
                {
                  attrs: {
                    loading: _vm.loading,
                    bordered: false,
                    "body-style": { paddingRight: "5" },
                    "data-step": "5",
                    "data-title": "零售统计",
                    "data-intro": "统计往前6个月每月零售的总金额",
                  },
                },
                [
                  _c("bar", {
                    attrs: {
                      title: "零售统计",
                      height: _vm.barHeight,
                      yaxisText: _vm.yaxisText,
                      dataSource: _vm.retailPriceData,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "12px" },
              attrs: { sm: 24, md: 12, xl: 8 },
            },
            [
              _c(
                "a-card",
                {
                  attrs: {
                    loading: _vm.loading,
                    bordered: false,
                    "body-style": { paddingRight: "5" },
                    "data-step": "6",
                    "data-title": "采购统计",
                    "data-intro": "统计往前6个月每月采购的总金额",
                  },
                },
                [
                  _c("bar", {
                    attrs: {
                      title: "采购统计",
                      height: _vm.barHeight,
                      yaxisText: _vm.yaxisText,
                      dataSource: _vm.buyPriceData,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "a-col",
            {
              style: { paddingRight: "0px", marginBottom: "6px" },
              attrs: { sm: 24, md: 24, xl: 24 },
            },
            [
              _c(
                "a-card",
                {
                  attrs: {
                    bordered: false,
                    "body-style": { padding: "5" },
                    "data-step": "7",
                    "data-title": "服务和版权",
                    "data-intro":
                      "展示服务到期时间（快到期时会出现续费链接，请注意及时续费）、\n        用户数量（是指最多可以录入的用户数量）、版权信息",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "hidden-xs",
                      staticStyle: { float: "right" },
                    },
                    [
                      _c(
                        "a-popover",
                        {
                          attrs: { trigger: "hover", visible: _vm.hovered },
                          on: { visibleChange: _vm.handleHoverChange },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c("img", {
                                staticStyle: { width: "258px" },
                                attrs: { src: "/static/weixin.jpg" },
                              }),
                            ]
                          ),
                          _vm.showWeixinSpan()
                            ? _c("a-button", { attrs: { type: "link" } }, [
                                _vm._v("忙果ERP微信小程序"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(
                        "\n          © 2015-2030 " +
                          _vm._s(_vm.systemTitle) +
                          " V3.6\n        "
                      ),
                    ],
                    1
                  ),
                  _vm.tenant.type == 0
                    ? _c("a-tag", { attrs: { color: "blue" } }, [
                        _vm._v("试用到期：" + _vm._s(_vm.tenant.expireTime)),
                      ])
                    : _vm._e(),
                  _vm.tenant.type == 0
                    ? _c("a-tag", { attrs: { color: "blue" } }, [
                        _vm._v(
                          "试用用户：" +
                            _vm._s(_vm.tenant.userCurrentNum) +
                            "/" +
                            _vm._s(_vm.tenant.userNumLimit)
                        ),
                      ])
                    : _vm._e(),
                  _vm.tenant.type == 1
                    ? _c("a-tag", { attrs: { color: "blue" } }, [
                        _vm._v("服务到期：" + _vm._s(_vm.tenant.expireTime)),
                      ])
                    : _vm._e(),
                  _vm.tenant.type == 1
                    ? _c("a-tag", { attrs: { color: "blue" } }, [
                        _vm._v(
                          "授权用户：" +
                            _vm._s(_vm.tenant.userCurrentNum) +
                            "/" +
                            _vm._s(_vm.tenant.userNumLimit)
                        ),
                      ])
                    : _vm._e(),
                  _vm.hasExpire
                    ? _c(
                        "a",
                        {
                          staticStyle: { color: "red" },
                          attrs: { href: _vm.payFeeUrl, target: "_blank" },
                        },
                        [_vm._v("立即续费")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }